import graphqlRequest from "../skillsMasteryRequest";
import GET_SKILL_RESOURCES from "./getSkillResourcesGraphql";

export async function getSkillResources(skillId, studentId, limit) {
  let inputs = {
    skillId,
    studentId,
    limit
  };

  return await graphqlRequest(GET_SKILL_RESOURCES, inputs);
}
